import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  max-width: 330px;
  /* margin: 0 auto; */
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
`;

export const Tr = styled.tr`
  border-bottom: 1px solid #e0e0e0;
`;

export const Td = styled.td`
  padding: 7px 4px;
  &:first-child {
    font-weight: 600;
    width: 110px;
  }
`;

export const TimeInput = styled.input`
  padding: 2px 6px;
  font-size: 15px;
  border: 1px solid #dadada;
  border-radius: 4px;
  min-width: 80px;
`;
